// extracted by mini-css-extract-plugin
module.exports = {"nav":"Menu_nav__1RI2X"};